module.exports = __webpack_public_path__ + "static/media/microphone-alt.306f3a03.svg";